export const corePalette = {
    blue: "#0382D7",
    green: "#4CAF50"
};

export const secondaryPalette = {
    blueBright: "#59C7FA",
    blueLight: "#CBE4F5"
};

export const greyPalette = {
    black: "#000000",
    darkGrey: "#444C57",
    grey: "#888C93",
    medGrey: "#CFD0D3",
    medLtGrey: "#E9E9E9",
    lightGrey: "#F5F5F5",
    faintGrey: "#FAFAFA",
    white: "#FFFFFF"
};

export const standardPalette = {
    coral: "#FF5252"
};

/*
	This color Palette will get imported into colors
	as the Chart array.
*/
export const pastelPalette = {
    blue: "#83C2FA",
    cyan: "#71D9E8",
    teal: "#72C48D",
    lime: "#E2ED8D",
    gold: "#FFDD70",
    redOrange: "#FFA183",
    pink: "#F582A8",
    violet: "#C985D4",
    indigo: "#949DD7"
};

export const fadedPalette = {
    red: "#FFE8E6",
    blue: "#DBF1FF",
    green: "#E9F3E7"
};

/*
	This color Palette will get imported into colors
	as the Heatmap array.
*/
export const saturatedPalette = {
    blue: "#2962FF",
    cyan: "#4FC3F7",
    lime: "#AEEA00",
    yellow: "#FFFF00",
    orange: "#FF8F00",
    magenta: "#F50057"
};

/*
	This color Palette will get imported into colors
	as the horse race segments array.
*/
export const tempPalette = {
    cold: "#fc5f55",
    cool: "#fc9e96",
    neutral: "auto",
    warm: "#9cddf9",
    hot: "#5fc9f8"
};

/*
    This color Palette will get importedx into colors
    for the Audience Expectations chart
*/
export const statusPalette = {
    good: "#75c378",
    bad: "#EC7063",
    ok: "#fec570",
    okGray: greyPalette.medGrey
};



// WEBPACK FOOTER //
// ./src/helpers/constants/colorPalettes.js